import '../public/css/bootstrap.min.css';
import '../public/css/style.scss';
import '../public/css/responsive.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import React, { useState, useEffect, Suspense } from 'react';
import { Poppins } from 'next/font/google';
import Router from 'next/router';
import Head from 'next/head';
import Loader from '../components/Shared/Loader';
import GoTop from '../components/Shared/GoTop';
import Matomo from '../components/Common/Matomo';
import { SettingsProvider } from '../context/settings';

// Poppins Font - nur tatsächlich verwendete Gewichte
const poppins = Poppins({
    subsets: ['latin'],
    weight: ['300', '400', '500', '600', '700', '800'],
    display: 'swap',
    variable: '--font-poppins',
    preload: true,
});

export default function MyApp({ Component, pageProps }) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 500);
        
        const handleRouteChange = () => {
            window.scroll({ top: 1, left: 0, behavior: 'smooth' });
        };
        
        Router.events.on('routeChangeComplete', handleRouteChange);
        
        return () => {
            clearTimeout(timer);
            Router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, []);

    return (
        <Suspense fallback={<Loader loading={true} />}>
            <Head>
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            </Head>
            
            <main className={poppins.className}>
                <Matomo />
                <SettingsProvider>
                    <Component {...pageProps} />
                </SettingsProvider>
                <Loader loading={loading} />
                <GoTop scrollStepInPx="100" delayInMs="10.50" />
            </main>
        </Suspense>
    );
}
